import { Modal } from '@pankod/refine-antd'

type Props = {
  infoText: string
  close: () => void
  modalProps: any
}

// This deliberately keeps the existing AdviceModal appearance. The only
// behavioral difference is that accepting it closes the dialog: no operation
// is resumed from a Warehouse block.
export const BlockingAdviceModal: React.FC<Props> = ({ infoText, modalProps, close }) => (
  <Modal
    style={{ zIndex: 800 }}
    {...modalProps}
    centered
    onCancel={close}
    onOk={close}
  >
    <b>{infoText}</b>
  </Modal>
)
